import raf from 'raf'
import type { Scrollbars } from 'react-custom-scrollbars'

import { getScrollParent } from './getScrollParent'

function easeOutQuad(t: number, b: number, c: number, d: number): number {
  const ts = (t /= d) * t
  const tc = ts * t
  return b + c * (-1 * ts * ts + 4 * tc + -6 * ts + 4 * t)
}

function isWindow(el: any): el is Window {
  return el === window
}

export function scrollTo(to: number, duration: number, element: Window | HTMLElement | Scrollbars | null = window) {
  return new Promise<void>(resolve => {
    let start = window.scrollY
    if (!isWindow(element)) {
      if (!element) {
        resolve()
        return
      }
      if ('getScrollTop' in element && typeof element.getScrollTop === 'function') {
        start = element.getScrollTop()
      } else if (typeof element.scrollTop === 'function') {
        start = element.scrollTop()
      } else {
        start = element.scrollTop
      }
    }

    const change = to - start
    const endTime = new Date().getTime() + duration

    raf(function animateScroll() {
      const currentTime = new Date().getTime()
      const progress = Math.min(duration, duration - (endTime - currentTime))
      const value = easeOutQuad(progress, start, change, duration)

      if (isWindow(element)) {
        element.scrollTo(0, value)
      } else if (typeof element.scrollTop === 'function') {
        element.scrollTop(value)
      } else {
        element.scrollTop = value
      }

      if (currentTime < endTime) {
        raf(animateScroll)
      } else {
        raf(resolve)
      }
    })
  })
}

export function scrollIntoView(el: Element, offset: number = 0, duration: number = 300) {
  const scrollParent = getScrollParent(el)
  const windowOffset = 'scrollY' in scrollParent ? scrollParent.scrollY : scrollParent.scrollTop
  const itemOffset = el.getBoundingClientRect().top
  return scrollTo(windowOffset - offset + itemOffset, duration, scrollParent)
}
